import React from "react";
import "./content-popup.css";

interface Props {
    ref?: any
};

const ContentPopup = React.forwardRef((props: any, ref?: any) => (
    // <div className="content-popup" ref={ref}>
    <div className="content-popup" ref={ref}>{props.children}</div>
    // </div>
));

export default ContentPopup;